import React from 'react'

import styles from './AdminOnly.scss'

export default function AdminOnly ({children, className}) {
  let admin = false
  try {
    admin = window.rwgps.ns('config').currentUser.account_level === 11
  } catch (e) {
    return false
  }
  return admin && <div className={className || styles.AdminOnly}>
    {children}
  </div>
}
